import React, { useState, useEffect, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { AppContext } from '../../application/provider';
import RhPracticantesService from '../../axios_services/rh_practicantes.service';
import ArchivosService from '../../axios_services/archivos.service';
import UsuariosService from '../../axios_services/usuarios.service';
import Loader from '../Loader/Loader';

const ModalRegistroPracticante = ({ isOpen, toggle, onSave, selectedItem, area_id }) => {
    const [state] = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(false);
    const [modoSeleccion, setModoSeleccion] = useState('manual');
    const [areaF, setAreaF] = useState(String(area_id || '1'));
    const [perfilF, setPerfilF] = useState('');
    const [usuarios, setUsuarios] = useState([]);
    
    const [boletaFile, setBoletaFile] = useState(null);
    const fileRef = React.useRef(null);

    const [formData, setFormData] = useState({
        rh_practicantes_id: null,
        apellidos_nombre: '',
        fecha_ingreso: '',
        total_pagar: 0,
        monto_regularizar: 0,
        desc_extra: 0,
        desc_cancelado: 0,
        desc_documento_observado: 0,
        retencion: 0,
        importe_neto_pagar: 0,
        dni: '',
        n_cuenta: '',
        n_cuenta_interbancaria: '',
        entidad_bancaria: '',
        estado_practicante: 'ACTIVO',
        fecha_cese: '',
    });

    const perfiles = state.catalogos?.perfiles || [];
    const filteredPerfiles = perfiles.filter(p => String(p.macro_area_id) === String(areaF));
    const entidades_bancarias = state.catalogos?.tipos?.filter(t => t.categoria_id == 25) || [];

    useEffect(() => {
        if (isOpen && modoSeleccion === 'usuario') {
            if (filteredPerfiles.length > 0 && (!perfilF || !filteredPerfiles.some(p => String(p.perfil_id) === String(perfilF)))) {
                setPerfilF(String(filteredPerfiles[0].perfil_id));
            }
            loadUsuarios();
        }
    }, [isOpen, areaF, perfilF, modoSeleccion]);

    const loadUsuarios = async () => {
        if (!perfilF || modoSeleccion !== 'usuario') return;
        setIsLoading(true);
        try {
            const now = new Date();
            const currentPeriod = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
            
            const resp = await UsuariosService.getUsuariosPorPeriodo(0, currentPeriod);
            const allUsers = resp.usuarios || resp.data || (Array.isArray(resp) ? resp : []);
            
            // Filtramos solo por perfil y estado, ya que el área ya filtró los perfiles disponibles
            const filtered = allUsers.filter(u => 
                String(u.perfil_id) === String(perfilF) &&
                String(u.estado) === '1'
            );
            setUsuarios(filtered);
        } catch (e) {
            console.error("Error al cargar usuarios:", e);
        } finally {
            setIsLoading(false);
        }
    };

    const handleUsuarioSelect = (e) => {
        const userId = e.target.value;
        const user = usuarios.find(u => String(u.usuario_id) === String(userId));
        if (user) {
            const tipos = state.catalogos?.tipos || [];
            const banco = tipos.find(t => String(t.tipo_id) === String(user.entidad_financiera_id));
            
            const fullName = (user.nombre_completo || user.nombre_completo_usuario || `${user.apellidos || ''} ${user.nombre || ''}`).trim().toUpperCase();

            setFormData(prev => ({
                ...prev,
                apellidos_nombre: fullName,
                fecha_ingreso: user.fecha_ingreso || '',
                dni: user.dni || '',
                n_cuenta: user.n_cuenta_bancaria || user.cuenta || '',
                n_cuenta_interbancaria: user.n_cuenta_interbancaria || user.cci || '',
                entidad_bancaria: user.entidad_financiera_id || ''
            }));
        }
    };

    useEffect(() => {
        if (selectedItem) {
            setFormData({
                rh_practicantes_id: selectedItem.rh_practicantes_id || null,
                apellidos_nombre: selectedItem.apellidos_nombre || '',
                fecha_ingreso: selectedItem.fecha_ingreso || '',
                total_pagar: selectedItem.total_pagar || 0,
                monto_regularizar: selectedItem.monto_regularizar || 0,
                desc_extra: selectedItem.desc_extra || 0,
                desc_cancelado: selectedItem.desc_cancelado || 0,
                desc_documento_observado: selectedItem.desc_documento_observado || 0,
                retencion: selectedItem.retencion || 0,
                importe_neto_pagar: selectedItem.importe_neto_pagar || selectedItem.total_pagar || 0,
                dni: selectedItem.dni || '',
                n_cuenta: selectedItem.n_cuenta || '',
                n_cuenta_interbancaria: selectedItem.n_cuenta_interbancaria || '',
                entidad_bancaria: selectedItem.entidad_bancaria || '',
                estado_practicante: selectedItem.estado_practicante || 'ACTIVO',
                fecha_cese: selectedItem.fecha_cese || '',
            });
            setModoSeleccion('manual');
            setBoletaFile(null);
            if (fileRef.current) fileRef.current.value = '';
        } else {
            setFormData({
                rh_practicantes_id: null,
                apellidos_nombre: '',
                fecha_ingreso: '',
                total_pagar: 0,
                monto_regularizar: 0,
                desc_extra: 0,
                desc_cancelado: 0,
                desc_documento_observado: 0,
                retencion: 0,
                importe_neto_pagar: 0,
                dni: '',
                n_cuenta: '',
                n_cuenta_interbancaria: '',
                entidad_bancaria: '',
                estado_practicante: 'ACTIVO',
                fecha_cese: '',
            });
            setModoSeleccion('manual');
        }
    }, [selectedItem, isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => {
            const updated = { ...prev, [name]: value };
            if (String(area_id) === '2') {
                const pago = parseFloat(updated.total_pagar) || 0;
                const reg = parseFloat(updated.monto_regularizar) || 0;
                const dExtra = parseFloat(updated.desc_extra) || 0;
                const dCanc = parseFloat(updated.desc_cancelado) || 0;
                const dObs = parseFloat(updated.desc_documento_observado) || 0;
                const ret = parseFloat(updated.retencion) || 0;
                updated.importe_neto_pagar = (pago + reg - dExtra - dCanc - dObs - ret).toFixed(2);
            } else {
                updated.importe_neto_pagar = updated.total_pagar;
            }
            return updated;
        });
    };

    const handleSave = async () => {
        setIsLoading(true);
        try {
            await onSave(formData, boletaFile);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="md" centered>
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{formData.rh_practicantes_id ? 'EDITAR REGISTRO' : 'NUEVO REGISTRO'} - PLANILLA PRACTICANTES</h1>
                    <button className="close-btn" onClick={toggle}>X</button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body p-4">
                    <Form className="px-4 mt-2">


                        {!formData.rh_practicantes_id && (
                            <FormGroup className="mb-4">
                                <Label>Modo de Registro</Label>
                                <Input 
                                    type="select" 
                                    value={modoSeleccion} 
                                    onChange={(e) => setModoSeleccion(e.target.value)}
                                    className="form-control"
                                    style={{ backgroundColor: '#f0f7ff' }}
                                >
                                    <option value="manual">INGRESO MANUAL</option>
                                    <option value="usuario">SELECCIONAR DE USUARIO</option>
                                </Input>
                            </FormGroup>
                        )}
                        {modoSeleccion === 'usuario' && !formData.rh_practicantes_id && (
                            <div className="mb-4">
                                <FormGroup className="mb-3">
                                    <Label>Seleccionar Área</Label>
                                    <Input 
                                        type="select" 
                                        value={areaF} 
                                        onChange={(e) => {
                                            setAreaF(e.target.value);
                                            setPerfilF('');
                                            setUsuarios([]);
                                        }}
                                        className="form-control"
                                        style={{ backgroundColor: '#f0f7ff' }}
                                    >
                                        <option value="1">ADMINISTRACIÓN</option>
                                        <option value="2">NEGOCIOS</option>
                                        <option value="4">GERENCIA</option>
                                    </Input>
                                </FormGroup>

                                <FormGroup className="mb-3">
                                    <Label>Seleccionar Perfil</Label>
                                    <Input 
                                        type="select" 
                                        value={perfilF} 
                                        onChange={(e) => setPerfilF(e.target.value)}
                                        className="form-control"
                                        style={{ backgroundColor: '#f0f7ff' }}
                                    >
                                        <option value="">Seleccione un perfil...</option>
                                        {filteredPerfiles.map(p => (
                                            <option key={p.perfil_id} value={p.perfil_id}>{p.descripcion.toUpperCase()}</option>
                                        ))}
                                    </Input>
                                </FormGroup>

                                <FormGroup className="mb-3">
                                    <Label>Seleccionar Usuario</Label>
                                    <Input 
                                        type="select" 
                                        onChange={handleUsuarioSelect}
                                        className="form-control"
                                        disabled={isLoading}
                                        style={{ backgroundColor: '#f0f7ff' }}
                                    >
                                    <option value="">{isLoading ? 'Cargando colaboradores...' : 'Seleccione un colaborador...'}</option>
                                        {usuarios.map(u => (
                                            <option key={u.usuario_id} value={u.usuario_id}>
                                                {(u.nombre_completo || u.nombre_completo_usuario || `${u.apellidos || ''} ${u.nombre || ''}`).trim().toUpperCase()}
                                            </option>
                                        ))}
                                    </Input>
                                    {isLoading && <div className="text-center mt-2"><small className="text-primary">Cargando lista de usuarios...</small></div>}
                                </FormGroup>
                                <hr />
                            </div>
                        )}

                        <FormGroup className="mb-3">
                            <Label for="apellidos_nombre">Apellidos y Nombres</Label>
                            <Input 
                                type="text" 
                                name="apellidos_nombre" 
                                id="apellidos_nombre" 
                                value={formData.apellidos_nombre} 
                                onChange={handleChange} 
                                className="form-control"
                                placeholder="Ingresa los apellidos y nombres completos"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="fecha_ingreso">Fecha de Ingreso</Label>
                            <Input 
                                type="date" 
                                name="fecha_ingreso" 
                                id="fecha_ingreso" 
                                value={formData.fecha_ingreso} 
                                onChange={handleChange} 
                                className="form-control"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="total_pagar">{String(area_id) === '2' ? 'Pago por Producción Mes' : 'Total a Pagar (Remuneración)'}</Label>
                            <Input 
                                type="number" 
                                name="total_pagar" 
                                id="total_pagar" 
                                value={formData.total_pagar} 
                                onChange={handleChange} 
                                className="form-control"
                                placeholder={String(area_id) === '2' ? "Ingresa el pago por producción" : "Ingresa el monto total a pagar"}
                            />
                        </FormGroup>

                        {String(area_id) === '2' && (
                            <>
                                <FormGroup className="mb-3">
                                    <Label for="monto_regularizar">Monto a Regularizar Meses Anteriores</Label>
                                    <Input type="number" name="monto_regularizar" id="monto_regularizar" value={formData.monto_regularizar} onChange={handleChange} className="form-control" placeholder="0.00" />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <Label for="desc_extra">Desc. Extra</Label>
                                    <Input type="number" name="desc_extra" id="desc_extra" value={formData.desc_extra} onChange={handleChange} className="form-control" placeholder="0.00" />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <Label for="desc_cancelado">Desc. Cancelado</Label>
                                    <Input type="number" name="desc_cancelado" id="desc_cancelado" value={formData.desc_cancelado} onChange={handleChange} className="form-control" placeholder="0.00" />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <Label for="desc_documento_observado">Desc. por Documento Observado</Label>
                                    <Input type="number" name="desc_documento_observado" id="desc_documento_observado" value={formData.desc_documento_observado} onChange={handleChange} className="form-control" placeholder="0.00" />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <Label for="retencion">Retención</Label>
                                    <Input type="number" name="retencion" id="retencion" value={formData.retencion} onChange={handleChange} className="form-control" placeholder="0.00" />
                                </FormGroup>
                                <FormGroup className="mb-3">
                                    <Label for="importe_neto_pagar" style={{ fontWeight: 'bold' }}>Importe Neto a Pagar</Label>
                                    <Input type="number" name="importe_neto_pagar" id="importe_neto_pagar" value={formData.importe_neto_pagar} disabled className="form-control" style={{ fontWeight: 'bold' }} />
                                </FormGroup>
                            </>
                        )}

                        <FormGroup className="mb-3">
                            <Label for="dni">DNI</Label>
                            <Input 
                                type="text" 
                                name="dni" 
                                id="dni" 
                                value={formData.dni} 
                                onChange={handleChange} 
                                className="form-control"
                                placeholder="Ingresa el número de DNI"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="entidad_bancaria">Entidad Bancaria</Label>
                            <Input 
                                type="select" 
                                name="entidad_bancaria" 
                                id="entidad_bancaria" 
                                value={formData.entidad_bancaria} 
                                onChange={handleChange} 
                                className="form-control"
                            >
                                <option value="">Seleccione un banco...</option>
                                {entidades_bancarias.map(b => (
                                    <option key={b.tipo_id} value={b.tipo_id}>
                                        {b.descripcion.toUpperCase()}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="n_cuenta">N° Cuenta</Label>
                            <Input 
                                type="text" 
                                name="n_cuenta" 
                                id="n_cuenta" 
                                value={formData.n_cuenta} 
                                onChange={handleChange} 
                                className="form-control"
                                placeholder="Ingresa el número de cuenta bancaria"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="n_cuenta_interbancaria">N° Cuenta Interbancaria (CCI)</Label>
                            <Input 
                                type="text" 
                                name="n_cuenta_interbancaria" 
                                id="n_cuenta_interbancaria" 
                                value={formData.n_cuenta_interbancaria} 
                                onChange={handleChange} 
                                className="form-control"
                                placeholder="Ingresa el código de cuenta interbancaria"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="estado_practicante">Estado</Label>
                            <Input 
                                type="select" 
                                name="estado_practicante" 
                                id="estado_practicante" 
                                value={formData.estado_practicante} 
                                onChange={handleChange}
                                className="form-control"
                            >
                                <option value="ACTIVO">ACTIVO</option>
                                <option value="CESADO">CESADO</option>
                            </Input>
                        </FormGroup>

                        {formData.estado_practicante === 'CESADO' && (
                            <FormGroup className="mb-3">
                                <Label for="fecha_cese">Fecha de Cese</Label>
                                <Input 
                                    type="date" 
                                    name="fecha_cese" 
                                    id="fecha_cese" 
                                    value={formData.fecha_cese} 
                                    onChange={handleChange} 
                                    className="form-control"
                                />
                            </FormGroup>
                        )}

                        <FormGroup className="mb-4">
                            <Label>Subir/Actualizar Boleta de Pago (PDF):</Label>
                            <div className="cap-upload-zone">
                                <span className="cap-upload-btn" onClick={() => fileRef.current?.click()}>
                                    {boletaFile ? boletaFile.name : 'Seleccionar archivo (PDF)'}
                                </span>
                                <input
                                    ref={fileRef}
                                    type="file"
                                    accept=".pdf"
                                    style={{ display: 'none' }}
                                    onChange={(e) => setBoletaFile(e.target.files[0] || null)}
                                />
                            </div>
                            {boletaFile && (
                                <small>
                                    <span style={{ cursor: 'pointer', color: '#f87171', fontSize: '10px' }} onClick={() => { setBoletaFile(null); if (fileRef.current) fileRef.current.value = ''; }}>
                                        ✕ Quitar selección
                                    </span>
                                </small>
                            )}
                            {selectedItem?.boleta_url && !boletaFile && (
                                <small className="text-success mt-1 d-block">
                                    ✓ Ya existe una boleta subida.{' '}
                                    <span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => window.open(selectedItem.boleta_url, '_blank')}>Ver documento</span>
                                </small>
                            )}
                        </FormGroup>

                        <div className="flex justify-end mt-4 pb-3">
                            <Button
                                className="btn-primary px-5 py-2"
                                onClick={handleSave}
                                style={{ borderRadius: '8px' }}
                            >
                                GUARDAR
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalRegistroPracticante;
